import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from './Modal';
import styles from './ModalContainer.css';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableDiv = testable(QA_MALT, 'div');

/**
 * Wrap a `<ModalContainer />` around some content and a `<Modal />`
 * to make the modal align to the content.
 */
const ModalContainer = ({ className, children, testId }) => (
  <TestableDiv className={classNames(className, styles.base)} testId={testId}>
    {React.Children.map(children, child => {
      if (child && child.type === Modal) {
        return {
          ...child,
          props: {
            ...child.props,
            inContainer: true,
          },
        };
      }

      return child;
    })}
  </TestableDiv>
);

ModalContainer.propTypes = {
  /** Add a custom className to the container */
  className: PropTypes.string,
  /** Contents of the container */
  children: PropTypes.node.isRequired,
  /** define a testid for the modal container */
  testId: PropTypes.string,
};

ModalContainer.displayName = 'ModalContainer';

export default ModalContainer;
